import { map, keys, join } from 'lodash/fp'
import filterStatusConfig from '../../assets/filterStatusConfig.json'

export const parseCsv = (
  labels: Record<string, string>,
  datas: any[]
): string => {
  const header = join(',')(
    map((key: string) => labels[key as keyof typeof labels])(keys(labels))
  )
  const body = join('\r\n')(
    map((data: any) => {
      return join(',')(
        map((key: string) => {
          if (key === 'statusCd') {
            return `${data[key]}: ${
              filterStatusConfig[data[key] as keyof typeof filterStatusConfig]
            }`
          } else {
            return data[key]
          }
        })(keys(labels))
      )
    })(datas)
  )
  return `${header}\r\n${body}`
}